export default __webpack_public_path__ + "static/media/mobilePGroup.d4193d13.png";